import { inject, Injectable, signal } from '@angular/core';
import { GlobalEventsService } from '../global-events.service';
import { filter, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { PlatformService } from '../platform.service';
import { merge, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class GameIframeService {
  private _events = inject(GlobalEventsService);
  private _router = inject(Router);
  private _platform = inject(PlatformService);


  /**
   * Game source
   */
  public source = signal<string | null>(null);

  /**
   * Toggle for pip game (toggle class for change styles)
   */
  public isPip = signal<boolean>(false);

  /**
   * Height for game iframe
   */
  public height = signal<number>(0);

  /**
   * Game data
   */
  public game = signal<any>(null);

  /**
   * Emit if close game iframe
   */
  public expandGame$: Subject<boolean> = new Subject();

  public isShowFrame = signal(false);

  constructor() {
    merge(
      this._events.resize$,
      this._events.fullscreenChangeEvent$
    ).pipe(
      filter(() => Boolean(this.source())),
      tap(() => this.setIframeHeight())
    ).subscribe();
  }

  /**
   * Toggle pip game (toggle class for styles)
   * @param isPip
   */
  public togglePipGame(isPip: boolean) {
    this.isPip.set(isPip);
    this._router.navigateByUrl(isPip ? '/' : `/play/${this.game().slug}`).then();
    if (!isPip) {
      this.expandGame$.next(true);
    }
  }

  /**
   * Set height for iframe height (init and resize)
   */
  public setIframeHeight() {
    if (this._platform.isBrowser && this.source()) {
      const container = document.querySelector('.game-container > .container .game-screen .game');
      this.height.set(container && container.getBoundingClientRect().height);
    }
  }

  /**
   * Set data for working pip
   * @param game
   * @param source
   */
  public resolveGame(game: any, source: any) {
    this.closeGame();
    this.source.set(source);
    this.game.set(game);
    this.setIframeHeight();
  }

  /**
   * Close game and remove data
   */
  public closeGame() {
    this.source.set(null);
    this.game.set(null);
    this.isPip.set(false);
    this.expandGame$.next(true);
  }
}
